import { connect } from 'react-redux';
import { selectors as tokenSelectors } from 'store/jwtMiddleware/tokenDuck';
import { initialize } from '../../actions/init';
import { initializeFoundation } from '../../actions/zitadel';
import { selectors as authSelectors } from '../../ducks/authDuck';
import { selectors as configurationSelectors } from '../../ducks/configurationDuck';
import { selectors as userSelectors } from '../../ducks/userDuck';

import Initialize from './Initialize';

const mapStateToProps = state => ({
  configurationInitialized: configurationSelectors.initialized(state) || !!configurationSelectors.fetchError(state),
  user: userSelectors.user(state),
  organizationShortName: userSelectors.organizationShortName(state),
  token: authSelectors.token(state),
  invalidRoles: tokenSelectors.invalidRoles(state),
});

const mapDispatchToProps = {
  initializeFoundation: initializeFoundation,
  initialize: initialize,
};

export default connect(mapStateToProps, mapDispatchToProps)(Initialize);
